let mixCallbacks = []
let callbacks = []
export const queue = async (callback = async () => {}) => {
  callbacks.push(callback)
}
export const mixQueue = async (callback = async () => {}) => {
  mixCallbacks.push(callback)
}

export const dequeue = async () => {
  try {
    const { length } = callbacks
    for (let i = 0; i < length; i++) {
      const callback = callbacks[i]
      await callback()
    }
    callbacks = []
  } catch (err) {
    console.log(err)
  }
}
export const mixDequeue = async () => {
  try {
    const { length } = mixCallbacks
    for (let i = 0; i < length; i++) {
      const callback = mixCallbacks[i]
      await callback()
    }
    mixCallbacks = []
  } catch (err) {
    console.log(err)
  }
}
